module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.0ffa5a7.woff2";